/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type WaitlistSignupResponse = "Allowed" | "Claimed" | "Queued" | "%future added value";
export type JoinWaitlistMutationInput = {
    clientMutationId?: string | null | undefined;
    email: string;
    role?: string | null | undefined;
};
export type JoinWaitlistMutationVariables = {
    input: JoinWaitlistMutationInput;
};
export type JoinWaitlistMutationResponse = {
    readonly joinWaitlist: {
        readonly clientMutationId: string | null;
        readonly response: WaitlistSignupResponse;
    } | null;
};
export type JoinWaitlistMutation = {
    readonly response: JoinWaitlistMutationResponse;
    readonly variables: JoinWaitlistMutationVariables;
};



/*
mutation JoinWaitlistMutation(
  $input: JoinWaitlistMutationInput!
) {
  joinWaitlist(input: $input) {
    clientMutationId
    response
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "JoinWaitlistMutationPayload",
            "kind": "LinkedField",
            "name": "joinWaitlist",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "response",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "JoinWaitlistMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "JoinWaitlistMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "f374f9ed31a83e71dfe4506bec429e95",
            "id": null,
            "metadata": {},
            "name": "JoinWaitlistMutation",
            "operationKind": "mutation",
            "text": "mutation JoinWaitlistMutation(\n  $input: JoinWaitlistMutationInput!\n) {\n  joinWaitlist(input: $input) {\n    clientMutationId\n    response\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '9ef7535c1b60fd9d10f38e1068395536';
export default node;
